import useSWR from 'swr';
import { BASE_URI } from '@utils/configPublic';
import { MarketplaceQuery, MarketplaceResponse } from '@pages/api/marketplace';
import { ErrorMessage } from '@utils/error';

export function useMarketplaceProjects(query?: MarketplaceQuery) {
  const url = `${BASE_URI}/api/marketplace?${new URLSearchParams(query as Record<string, string>)}`;
  const res = useSWR<MarketplaceResponse, { info: ErrorMessage }>(url);
  return res;
}
